/*
  Once properly migrated to scss.modules, this file should be removed 
  and the imports in this file should be moved to the appropriate places.
  - MRA
*/
import './scaffold/styles/global.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { SentryClient } from '@smart-tv/sentry/SentryClient';

import App from './app';
import { GDPRProvider, TvProvider } from './contexts';
import { CookieConsentProvider } from './contexts/cookie-consent-context/cookie-consent-context';
import { AuthenticationProvider } from './contexts/authentication-context';
import { IS_BROWSER } from './utils/is-browser';
import retrieveDeviceId from './utils/device-id-generation';
import { storeNetworkSpeed } from './utils/network-speed';
import { installBackKeyLayers } from './utils/back-key-layers';

// Must be installed before any other window capture keydown listener to take precedence
installBackKeyLayers();

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
  SentryClient.initialize();
  if (window.tizen) {
    import('tizen-tv-webapis').then(({ productinfo }) => {
      SentryClient.setModel(productinfo.getRealModel());
    });
  }
}

const main = async () => {
  // make sure UID is set before rendering the app as all API calls require it
  retrieveDeviceId();

  // the Networkspeed on TV after the first installation is handled by the player's BitrateChanged event
  // since my empirical tests have found it's too unreliable to measure on TV on startup
  // It only affects the very first installation and first stream - afterwards it gets correct reading on TV also
  if (IS_BROWSER) {
    storeNetworkSpeed();
  }

  const container = document.getElementById('root') as HTMLElement;
  const root = createRoot(container);

  root.render(
    <AuthenticationProvider>
      <GDPRProvider>
        <CookieConsentProvider>
          <TvProvider>
            <App />
          </TvProvider>
        </CookieConsentProvider>
      </GDPRProvider>
    </AuthenticationProvider>
  );
};

main();
